export const documentsSignedAuthorizationsCapability = 'documents.signed-authorizations.v1';
export const documentsSignedCompletionsCapability = 'documents.signed-completions.v1';
export const documentsInsuranceClaimsReadinessProviderId = 'documents.server.insurance-claims-readiness';
export const documentsInsuranceClaimsAuthorizationTemplateKeys = [
    'work_auth',
    'work_authorization',
    'synthetic_work_authorization',
];
export const documentsInsuranceClaimsCompletionTemplateKeys = [
    'coc',
    'completion_cert',
    'certificate_of_completion',
    'synthetic_certificate_of_completion',
];
//# sourceMappingURL=documents-insurance-claims-readiness.contract.js.map